import { TimeUnit } from '../../../utils/apollo/graphqlSchema';
import DatePickerDisplay from '../../Builder/DatePickerWidget/DateRangeDisplay/DatePickerDisplay';
import { getCapitalizedTimeUnitText } from '../../../utils';
import { datePickerFromAnalysisInfo } from '../../Builder/DatePickerWidget/utils';
import DateDisplay from '../../Builder/DatePickerWidget/DateRangeDisplay/DateDisplay';
import useSyndicateTimezoneLabel from '../../../utils/hooks/useSyndicateTimezoneLabel';
import styled from 'styled-components';
import { useChartContext } from '../ChartContext';
import { ChartMode } from '../types';
import { theme } from '../../../styles/theme';

const Container = styled.div<{ $color: string }>`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  column-gap: 4px;
  flex-wrap: wrap;
  font-size: 10px;
  color: ${({ $color }) => $color};
`;

const ChartHeaderDateRange = () => {
  const {
    metadata: { mode, datePicker, startDate, endDate, timeUnit, query },
  } = useChartContext();

  // query.includeMissingDates is only available for Expression
  const notIncludeMissingDates =
    query.__typename === 'ExpressionQuery' && !query.includeMissingDates;

  const shortSyndicateTimeZone = useSyndicateTimezoneLabel();

  return (
    <Container
      $color={
        mode === ChartMode.Build
          ? theme.colors.secondary800
          : theme.colors.secondary600
      }
    >
      {timeUnit !== TimeUnit.Na && (
        <>
          {getCapitalizedTimeUnitText(timeUnit).adverb}
          <span>&#8226;</span>
        </>
      )}
      <span>
        <DatePickerDisplay
          datePicker={datePickerFromAnalysisInfo({
            start: startDate,
            end: endDate,
            datePicker,
          })}
          hideFixedDateRange={true}
        />
      </span>
      <span>&#8226;</span>
      <DateDisplay date={startDate} /> - <DateDisplay date={endDate} />{' '}
      {shortSyndicateTimeZone}
      {notIncludeMissingDates && (
        <>
          <span>&#8226;</span>
          <span>Excluding missing dates</span>
        </>
      )}
    </Container>
  );
};

export default ChartHeaderDateRange;
